import {Box, Typography} from '@mui/material';
import {useState} from 'react';
import useLoadAds from '@jobseeker/common-core/hooks/useLoadAds';

import {Image} from '@jobseeker/lotus/components/Image';
import {PartnerCardDataType} from './types';
import {useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';

const HeroPartnerSection = () => {
  const {
    timelines: {ads},
  } = useSelector((state: AppState) => state.competition);

  const partner1Slot = ads?.partnerCompanies1?.slotId ?? '';
  const partner2Slot = ads?.partnerCompanies2?.slotId ?? '';

  const [partners1, setPartners1] = useState<PartnerCardDataType[]>([]);
  const [partners2, setPartners2] = useState<PartnerCardDataType[]>([]);

  useLoadAds(partner1Slot, setPartners1, {}, false);
  useLoadAds(partner2Slot, setPartners2, {}, false);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          background: '#fff',
          boxShadow: '0 6px 24px 0 rgba(0, 0, 0, 0.07)',
          borderBottomLeftRadius: 36,
          borderBottomRightRadius: 36,
          overflow: 'auto',
        }}
      >
        <Box
          display="block"
          px={{xs: 3.5, md: 7.5}}
          sx={{
            marginTop: 3,
            marginBottom: 4.5,
            lineHeight: 1,
            borderRight: '2px solid #e8e8f4',
            marginRight: {xs: 3, md: 9},
          }}
        >
          <Typography
            sx={{fontSize: {xs: '18px', md: '32px'}, fontWeight: 300}}
          >
            Partner
          </Typography>
          <Typography
            sx={{fontSize: {xs: '22px', md: '32px'}, fontWeight: 600}}
          >
            Companies
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}
        >
          {partners1.map((partner1, index) => (
            <Box
              key={`adimages-${index}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginRight: {md: '51px', xss: '3px'},
              }}
            >
              <Image
                src={partner1?.companyLogo}
                alt="Company Logo"
                width={130}
                height={70}
                quality={50}
                placeholder="blur"
                blurDataURL={partner1?.companyLogo}
                objectFit="contain"
              />
            </Box>
          ))}
          {partners2.map((partner2, index) => (
            <Box
              key={`adimages-${index}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginRight: {md: '51px', xss: '3px'},
              }}
            >
              <Image
                src={partner2?.companyLogo}
                alt="Company Logo"
                width={130}
                height={70}
                quality={50}
                placeholder="blur"
                blurDataURL={partner2?.companyLogo}
                objectFit="contain"
              />
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default HeroPartnerSection;
